import { render, staticRenderFns } from "./SignDoc.vue?vue&type=template&id=6d1ad150&scoped=true"
import script from "./SignDoc.vue?vue&type=script&lang=js"
export * from "./SignDoc.vue?vue&type=script&lang=js"
import style0 from "./SignDoc.vue?vue&type=style&index=0&id=6d1ad150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ad150",
  null
  
)

export default component.exports